import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19d0854c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-auth-wrap" }

import { ref, onMounted } from 'vue';
import { useUserStore, useSystemStore } from '@/store';
import { getLoginProjects, getMyAuth } from '@/api/myAuth';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const userStore = useUserStore();
const systemStore = useSystemStore();

const { projectId } = systemStore.projectInfo || {};

const formData = ref({
  userName: '',
  mobile: '',
  departmentsText: '',
  workContent: '',
  applyReason: ''
});

const detail = ref<MyAuth.MyAuthDetail>({
  userName: '',
  mobile: '',
  departmentsText: '',
  departments: [],
  departmentTree: [],
  roles: []
});

onMounted(() => {
  const { userInfo } = userStore;
  if (userInfo) {
    const departmentsText = getDepartmentsText(userInfo.depentments || []);

    formData.value.userName = userInfo.userName;
    formData.value.mobile = userInfo.mobile;
    formData.value.departmentsText = departmentsText;
  }
  getAuthInfos();
});

const getAuthInfos = async () => {
  const res = await getLoginProjects();
  const { code, data } = res;
  if (`${code}` === '0' && data) {
    const authRes = await getMyAuth(projectId!);
    const { code: authCode, data: authData } = authRes;
    if (`${authCode}` === '0' && authData) {
      detail.value = authData;
      detail.value.departmentsText = getDepartmentsText(authData.departments);
    }
  }
};

const getDepartmentsText = (depentments: Basic.Department[]) => {
  const res: string[] = [];
  depentments.forEach((item) => {
    const dNameArr = getDepartmentNameArr(item, []);
    res.push(dNameArr.join('-'));
  });

  function getDepartmentNameArr(depentment: Basic.Department, departmentNameArr: string[]) {
    departmentNameArr.push(depentment.departmentName);
    if (depentment.next) {
      getDepartmentNameArr(depentment.next, departmentNameArr);
    }
    return departmentNameArr;
  }
  return res.join(';');
};

return (_ctx: any,_cache: any) => {
  const _component_e_block = _resolveComponent("e-block")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_e_form_item = _resolveComponent("e-form-item")!
  const _component_e_form = _resolveComponent("e-form")!
  const _component_EContent = _resolveComponent("EContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_EContent, { block: true }, {
      header: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_e_block, {
            title: "我的权限",
            sider: false
          })
        ])
      ]),
      main: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_e_form, {
            class: "detail-form",
            model: detail.value,
            "label-width": "90px",
            "label-position": "right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_alert, {
                class: "mb20",
                title: "如您需要变更系统权限，请联系对应的系统管理员",
                type: "warning",
                "show-icon": "",
                closable: false
              }),
              _createVNode(_component_e_form_item, { label: "用户名称" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(detail.value.userName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_e_form_item, { label: "手机号" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(detail.value.mobile), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_e_form_item, { label: "组织" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(detail.value.departmentsText), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_e_form_item, { label: "角色" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.roles, (item) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: item.id
                      }, _toDisplayString(`${item.sysName}-${item.projectName}-${item.roleName}`), 1))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})